<script setup>
defineProps({ blok: { type: Object, default: () => ({ body: [] }) } });
</script>

<template>
  <div v-editable="blok">
    <component
      :is="blok.component"
      v-for="blok in blok.body"
      :key="blok._uid"
      :blok="blok"
    />
  </div>
</template>
